(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dhajia-property-tour"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dhajia-property-tour')) {
    customElements.define('dhajia-property-tour', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.dialog = this.querySelector('dialog');
        this.video = this.dialog?.querySelector('video');
        this.opener = this.querySelector('[data-tour-open]');
        if (!this.dialog || !this.video || !this.opener) return;
        this.opener.addEventListener('click', () => {
          this.returnFocus = document.activeElement;
          this.dialog.showModal();
          this.video.muted = false;
          this.video.loop = false;
          this.track('open');
          const playback = this.video.play();
          if (playback && typeof playback.catch === 'function') playback.catch(() => {});
        }, options);
        this.querySelector('[data-tour-close]').addEventListener('click', () => this.dialog.close(), options);
        this.dialog.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const bounds = this.dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
        }, options);
        this.dialog.addEventListener('close', () => {
          this.video.pause();
          this.track('close');
          if (this.returnFocus?.isConnected) this.returnFocus.focus({ preventScroll: true });
        }, options);
        this.video.addEventListener('play', () => this.track('play'), options);
        this.video.addEventListener('ended', () => this.track('complete'), options);
        this.video.addEventListener('error', () => {
          const error = this.querySelector('.dhajia-property-tour__error');
          if (error) error.hidden = false;
          this.track('error');
        }, options);
      }
      disconnectedCallback() {
        this.video?.pause();
        if (this.dialog?.open) this.dialog.close();
        this.controller?.abort();
        this.controller = null;
      }
      track(action) {
        if (Array.isArray(window.dataLayer)) window.dataLayer.push({
          event: `dhajia_property_tour_${action}`,
          product_id: this.dataset.productId,
          product_handle: this.dataset.productHandle
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
